
const PriceDisplay = ({ value }) => (
  <div className="mb-3">
    <label htmlFor="price" className="form-label fw-semibold">
      Prix unitaire
    </label>
    <input
      type="text"
      className="form-control bg-light"
      id="price"
      value={value ? parseFloat(value).toLocaleString() + ' Fcfa' : ''}
      readOnly
      disabled
    />
    <div className="form-text">
      Prix défini par l'ordre sélectionné (lecture seule)
    </div>
  </div>
);

export default PriceDisplay;